import { Directive, ElementRef, Input, AfterViewInit, DoCheck } from '@angular/core';
import { PieChartComponent } from '@swimlane/ngx-charts';

@Directive({
  selector: '[arcOuterStroke]',
  standalone: false,
})
export class PieArcBorder implements DoCheck, AfterViewInit {
  @Input('arcOuterStroke') color: string;

  private lastResults: any;

  constructor(
    private elRef: ElementRef,
    private pie: PieChartComponent
  ) {}

  ngAfterViewInit(): void {
    if (this.lastResults !== this.pie.results) {
      this.update();
    }
  }
  ngDoCheck(): void {
    if (this.lastResults !== this.pie.results) {
      this.update();
    }
  }

  private update(): void {
    if (this.color) {
      this.lastResults = this.pie.results;

      const arcs: HTMLElement[] = this.elRef.nativeElement.querySelectorAll('.arc');
      if (arcs && this.pie.results) {
        if (this.pie.results.length === arcs.length) {
          let total = 0;

          for (let i = 0; i < arcs.length; i++) {
            const item = this.pie.data[i];
            if (item) {
              total += item.value;
            }
          }

          const circ = 2 * Math.PI * this.pie.outerRadius;
          for (let i = 0; i < arcs.length; i++) {
            const item = this.pie.data[i];
            if (item) {
              const size = (circ * item.value) / total;
              const fullSize = size * 2 + 2 * this.pie.arcWidth * this.pie.outerRadius;
              arcs[i].setAttribute('stroke', this.color);
              arcs[i].setAttribute('stroke-dasharray', (fullSize + size).toString());
              arcs[i].setAttribute('stroke-dashoffset', fullSize.toString());
            }
          }
        } else {
          setTimeout(() => this.update(), 32);
        }
      }
    }
  }
}
